import React from "react";
import style from "./contacto.module.scss";
import { useForm } from "react-hook-form";
import contacto from "../../assets/img/svgUtils/contacto.svg";
import { CircularProgress } from "@mui/material";
import { AnimationOnScroll } from "react-animation-on-scroll";

function ContactoComponent({ items }) {
  const { fn, status } = items;
  const errMsg = {
    justifyContent: "flex-start",
    fontSize: "12px",
    color: "white",
    marginLeft: "1rem",
  };
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  return (
    <div className={style.container}>
      <h2>
        <span className={style.subrayado}>CONTACT</span>AME
      </h2>
      <AnimationOnScroll
        className={style.childContainer}
        animateIn="fadeIn"
        animateOnce={true}
        duration={1.8}
      >
        <div className={style.imgContainer}>
          <img src={contacto} alt="mandarMail" />
        </div>
        <div className={style.formContainer}>
          <form
            onSubmit={handleSubmit(async (data) => {
              await fn(data);
              reset();
            })}
          >
            <div className={style.inputContainer}>
              <label>Nombre:</label>
              <input
                className={style.inputText}
                type="text"
                placeholder="Tu nombre ..."
                {...register("nombre", {
                  required: {
                    value: true,
                    message: "*Campo obligatorio",
                  },
                })}
              />
              <div className={style.error}>
                {errors.nombre && (
                  <span style={errMsg}>{errors.nombre.message}</span>
                )}
              </div>
            </div>
            <div className={style.inputContainer}>
              <label>Email:</label>
              <input
                className={style.inputText}
                id="email"
                type="text"
                placeholder="Tu email ..."
                {...register("email", {
                  required: {
                    value: true,
                    message: "*Campo obligatorio",
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "El formato no es correcto",
                  },
                })}
              />
              <div className={style.error}>
                {errors.email && (
                  <span style={errMsg}>{errors.email.message}</span>
                )}
              </div>
            </div>
            <div className={style.inputContainer}>
              <label>Mensaje</label>
              <textarea
                className={style.inputTextArea}
                placeholder="Hola Lean, me contacto por este medio para ..."
                {...register("mensaje", {
                  required: {
                    value: true,
                    message: "*Campo obligatorio",
                  },
                })}
              />
              <div className={style.error}>
                {errors.mensaje && (
                  <span style={errMsg}>{errors.mensaje.message}</span>
                )}
              </div>
            </div>
            <div className={style.inputContainer}>
              {!status.loading ? (
                <input className={style.submit} type="submit" value="ENVIAR" />
              ) : (
                <CircularProgress />
              )}
            </div>
            <div className={style.avisoContainer}>
              {status.alert ? <span>{status.msg}</span> : null}
            </div>
          </form>
        </div>
      </AnimationOnScroll>
    </div>
  );
}

export default ContactoComponent;
